import { useState } from "react";
import { FAQ_LIST } from "@/mocks/home";
import SectionHeader from "./SectionHeader";

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return (
    <section id="faq" className="bg-background-50 py-14 md:py-20">
      <SectionHeader
        eyebrow="吃瓜 FAQ"
        title="关于本月大瓜的常见问题"
        desc="围绕本站的更新频率、内容来源、参与方式等问题做统一说明。对应问答亦已按 FAQPage 结构化数据标注。"
        accent
      />
      <div className="mx-auto mt-8 max-w-4xl px-4 md:px-6">
        <div className="flex flex-col divide-y divide-background-200 overflow-hidden rounded-2xl border border-background-200 bg-background-100">
          {FAQ_LIST.map((item, idx) => {
            const active = open === idx;
            return (
              <div key={idx} className="bg-background-50/60">
                <button
                  type="button"
                  onClick={() => setOpen(active ? null : idx)}
                  aria-expanded={active}
                  className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left transition hover:bg-background-100"
                >
                  <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                    <span className="mr-2 text-primary-600">Q{idx + 1}.</span>
                    {item.q}
                  </span>
                  <i
                    className={`shrink-0 text-xl text-primary-600 transition-transform duration-300 ${
                      active ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  />
                </button>
                {active && (
                  <p className="animate-fade-up border-t border-background-200 px-5 pt-4 pb-5 text-sm leading-relaxed text-foreground-600">
                    <span className="mr-2 font-bold text-accent-700">A{idx + 1}.</span>
                    {item.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}